import React from 'react';
import {MobileCarouselState} from '../types';

import {calcPosition} from '../helpers';

import {ThemeDefinition} from '@volkswagen-onehub/components-core';

export interface UpdateGalleryParams {
    itemCount: number;
    setState: React.Dispatch<React.SetStateAction<MobileCarouselState>>;
    activeSlideIndex: number;
    hideNextSlide?: boolean;
    isWideSlide?: boolean;
    direction: ThemeDefinition['direction'];
    // Optional: pass a custom calculation function for testing
    calcPositionFn?: (
        activeSlideIndex: number,
        itemCount: number,
        hideNextSlide?: boolean,
        isWideSlide?: boolean,
        direction?: ThemeDefinition['direction']
    ) => number;
}

export function useUpdateGalleryOnLentilClick({
    itemCount,
    setState,
    activeSlideIndex,
    hideNextSlide,
    isWideSlide,
    direction,
    calcPositionFn = calcPosition
}: UpdateGalleryParams) {
    const position = React.useMemo(
        () =>
            calcPositionFn(
                activeSlideIndex,
                itemCount,
                hideNextSlide,
                isWideSlide,
                direction
            ),
        [
            activeSlideIndex,
            itemCount,
            hideNextSlide,
            isWideSlide,
            direction,
            calcPositionFn
        ]
    );

    React.useEffect(() => {
        if (!itemCount) return;

        setState(prevState => {
            if (prevState.position === position) {
                return prevState;
            }
            return {...prevState, position};
        });
    }, [position, itemCount, setState]);
}
